const SideNavSelectors = {
  getIsCollapsed(store) {
    return store.admin.sideNav.isCollapsed;
  } 
};

export { SideNavSelectors };